<div class="portfolio-graduation">
  <div class="pre-page spen-mod-heading lv-1">
    <h1 class="heading-text">
      <button class="spen-mod-btn is-primary" (click)="slideMenu()"><i class="fa fa-reorder"></i></button>ポートフォリオ卒業
    </h1>
  </div>

  @if (contentLoaded) {
    <div class="portfolio-content">
      <p class="portfolio-title">ポートフォリオダウンロード</p>
      <p class="portfolio-note">
        卒業後にいかせそうな経験はありましたか？ぜひ、ダウンロードして、いつでも振り返りできるようにしてくださいね。
      </p>
      @if (studentSummaries.length > 0) {
        <div class="student-summaries">
          <p class="student-summaries-title">できるようになったこと</p>
          @for (summary of studentSummaries; track summary.activity_record_id) {
            <div class="summary" (click)="eventShowActivity(summary.activity_record_id)">
              <div class="published-date">
                {{ summary.created_at }}
                @for (mark of summary.marks; track mark.id) {
                  <img class="mark" src="{{ mark.icon }}" />
                }
              </div>
              <div class="summary-area">
                <div class="text-block">
                  <p class="summary-title">{{ summary.title }}</p>
                  <p class="summary-content">{{ summary.content | trimText: 50 }}</p>
                </div>
                <div class="summary-thumb">
                  @if (summary.upload_picture?.thumbnail) {
                    <img src="{{ summary.upload_picture.thumbnail }}" />
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
      <div class="action">
        @if (layoutService.isTabletDownView.value) {
          <!-- SP画面 -->
          <div class="action-sp">
            <p class="action-note">
              パソコンをお使いいただくことで、Classiポートフォリオの活動記録や添付ファイルなど、すべてのデータをダウンロードできます。
            </p>
          </div>
        } @else {
          <!-- PC画面 -->
          <div class="action-pc">
            <button class="spen-mod-btn is-primary" [disabled]="progress !== null" (click)="onClickPortfolioDownload()">
              ポートフォリオをダウンロード
            </button>
            <a #portfolioDownloadLink class="hidden-link" download></a>
            <p class="action-note">※ご利用状況によりダウンロードには時間がかかることがあります。</p>
          </div>
        }
      </div>
    </div>
    <div class="graduation-content">
      <div class="graduation-heading">
        <p class="graduation-title">卒業メッセージ</p>
      </div>
      @if (listLoaded) {
        <div class="data-info">
          <p class="page-info">{{ page() | paginateText }}</p>
        </div>
        <!-- SP画面 -->
        @if (layoutService.isTabletDownView.value) {
          <div class="message-sp">
            <div class="list-submission">
              @for (graduation_message of graduationMessages; track graduation_message.id; let last = $last) {
                <div class="list-item clickable-item" [class.last]="last" (click)="onClickGraduationMessage(graduation_message.id)">
                  <div class="info">
                    <p class="truncate-text message-title">
                      <b>{{ graduation_message.title }}</b>
                    </p>
                    <p class="truncate-text creator-name">配信者：{{ graduation_message.create_user_name }}</p>
                    <p class="text-smaller delivered-time">配信日時：{{ graduation_message.created_at }}</p>
                    <p class="text-smaller truncate-text space-name">配信先：{{ graduation_message.space_name }}</p>
                  </div>
                  <i class="fa fa-chevron-right"></i>
                </div>
              }
              @if (showPagination) {
                <div class="spen-mod-paginate pagination-custom">
                  <spen-paginator [length]="page().total_pages" [pageIndex]="page().current_page - 1" (page)="pageChanged($event)" />
                </div>
              }
            </div>
          </div>
        } @else {
          <div class="message-pc">
            <div class="list-submission">
              <div class="spen-mod-flex-table table-list-full has-link">
                <div class="flex-table-head">
                  <div class="flex-item col-size-4 is-first-col">タイトル</div>
                  <div class="flex-item col-size-3">配信者</div>
                  <div class="flex-item col-size-3">配信日時</div>
                  <div class="flex-item col-size-4">配信先</div>
                  <div class="flex-item redirect-cell"></div>
                </div>
                @for (graduation_message of graduationMessages; track graduation_message.id) {
                  <a class="flex-table-row clickable-item" (click)="onClickGraduationMessage(graduation_message.id)">
                    <div class="flex-item col-size-4 is-first-col truncate-text">{{ graduation_message.title }}</div>
                    <div class="flex-item col-size-3 truncate-text">{{ graduation_message.create_user_name }}</div>
                    <div class="flex-item col-size-3">{{ graduation_message.created_at }}</div>
                    <div class="flex-item col-size-4 truncate-text">{{ graduation_message.space_name }}</div>
                    <div class="flex-item redirect-cell is-icon-item">
                      <i class="fa fa-chevron-right"></i>
                    </div>
                  </a>
                }
              </div>
              @if (showPagination) {
                <div class="spen-mod-paginate pagination-custom">
                  <spen-paginator [length]="page().total_pages" [pageIndex]="page().current_page - 1" (page)="pageChanged($event)" />
                </div>
              }
            </div>
          </div>
        }
        <!-- PC画面 -->
      } @else {
        <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
      }
    </div>
  } @else {
    <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
  }
</div>

@if (showActivityDetailModal) {
  <app-activity-detail-modal [activityId]="activityId" (eventForBackAction)="eventForBackAction($event)"> </app-activity-detail-modal>
}

@if (progress !== null) {
  <app-progress-indicator
    [title]="'ダウンロードの準備中'"
    [status]="progressStatus"
    [progress]="progress"
    [canCancel]="progressCanCancel"
    (clickCancel)="onCancelPortfolioDownload()"
  ></app-progress-indicator>
}
